import { render, staticRenderFns } from "./RecentMessages.vue?vue&type=template&id=2405bd46"
import script from "./RecentMessages.vue?vue&type=script&lang=js"
export * from "./RecentMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports